import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { WalletConnectService } from '../../services/wallet-connect.service';
import { NoWalletComponent } from '../no-wallet/no-wallet.component';
import { getParamWithoutCookie } from '../../shared/constants/app-enums';

@Component({
  selector: 'app-connect',
  templateUrl: './connect.component.html',
  styleUrls: ['./connect.component.scss'],
})
export class ConnectComponent implements OnInit {
  isBsNetwork: boolean = false;
  bwUrl = getParamWithoutCookie('bwUrl');

  constructor(
    private modalService: BsModalService,
    public modalRef: BsModalRef,
    private walletConnectService: WalletConnectService,
  ) {
    this.bwUrl = getParamWithoutCookie('bwUrl');
    if (this.bwUrl && this.bwUrl !== '') {
      this.walletConnectService.connectWallet('bw');
      if (this.modalRef) this.modalRef.hide();
    }
  }

  ngOnInit(): void {}

  connectWallet(mode: string): void {
    this.walletConnectService.connectWallet(mode, this.isBsNetwork);
    if (this.modalRef) this.modalRef.hide();
  }

  openBestWallet() {
    if (this.modalRef) this.modalRef.hide();
    setTimeout(() => {
      this.modalRef = this.modalService.show(NoWalletComponent, {
        class: 'modal-md modal-dialog-centered bw-modal',
        backdrop: 'static',
      });
    }, 500);
  }
}
